import type { ReactNode } from 'react';

import { AuthContext } from '../catedge';
import { useAuthStore } from '@/platform/stores/useAuthStore';

export function CatEdgeAuthProvider({ children }: { children: ReactNode }) {
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore(
    (state) => state.sessionStatus === 'unknown' || state.isCheckingSession
  );
  const signOut = useAuthStore((state) => state.logout);

  return <AuthContext.Provider value={{ user, loading, signOut }}>{children}</AuthContext.Provider>;
}
